import CreateBillingObject from './CreateBillingObject';
/**
 *
 * @param {Object} billingInformation - billing object can be from api structure or store structure
 * @param {Object} paymentInformation  - structure from store
 * @param {String} country  = NZ or AU
 * @param {String} email - user email
 *
 * @returns an object with payment details properties
 *
 * Used for:
 * payandcommit api
 * user/payment api
 */

const GeneratePaymentDetailsObject = (
	billingInformation,
	paymentInformation,
	country = 'NZ',
	email,
	isAddNewCC = false
) => {
	const { cardType, creditCardNumber, cvv, expirationMonth, expirationYear } =
		paymentInformation;

	return {
		billingAddress: CreateBillingObject(country, email, billingInformation),
		cardType,
		cardNumber: creditCardNumber,
		expirationMonth,
		expirationYear,
		cvv,
		type: isAddNewCC ? 'creditCardDetailsInput' : 'creditCard',
	};
};

export default GeneratePaymentDetailsObject;
